import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { SliderModule } from 'primeng/slider';
import { InputNumberModule } from 'primeng/inputnumber';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { ProgressBarModule } from 'primeng/progressbar';
import { StepsModule } from 'primeng/steps';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

export const APP_PRIMENG_MODULE = [
  ButtonModule,
  DialogModule,
  DropdownModule,
  MultiSelectModule,
  FileUploadModule,
  DividerModule,
  CardModule,
  TableModule,
  SliderModule,
  InputNumberModule,
  TooltipModule,
  ProgressSpinnerModule,
  AvatarModule,
  MenuModule,
  ProgressBarModule,
  CalendarModule,
  StepsModule,
  InputTextModule,
  AutoCompleteModule,
  MessageModule,
  MessagesModule,
  ToastModule,
  ConfirmDialogModule
];
